import React from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { COLORS, MONTHS_IT, fmtEur, fmtEurCompact } from "./eaFormat";
import { HatchDefs } from "./EaUi";

function statusLine(m, label) {
  if (!m || m.points_total === 0) return null;
  const est = m.spend_forecast != null ? ` · stima forecast ${fmtEur(m.spend_forecast)}` : "";
  if (m.invoice_status === "invoiced") return `${label}: fatturato ${fmtEur(m.spend)}`;
  if (m.invoice_status === "partial") return `${label}: fatturato ${fmtEur(m.spend)} (${m.points_invoiced}/${m.points_total} punti)${est}`;
  return `${label}: In attesa fattura${est}`;
}

function SpendTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="bg-white border border-slate-200 rounded-lg shadow-lg px-3 py-2 text-xs space-y-1">
      <div className="font-semibold text-slate-900">{d.label}</div>
      {[statusLine(d.pm, "Power"), statusLine(d.gm, "Gas")].filter(Boolean).map((t) => <div key={t} className="text-slate-600">{t}</div>)}
    </div>
  );
}

// Fatturato pieno; mesi non fatturati con la stima forecast del Report, tratteggiata.
export function EaMonthlySpendChart({ power, gas }) {
  const hasP = power?.points > 0, hasG = gas?.points > 0;
  const data = MONTHS_IT.map((label, i) => {
    const pm = hasP ? power.monthly[i] : null, gm = hasG ? gas.monthly[i] : null;
    return { label, pm, gm, power: pm?.spend ?? null, gas: gm?.spend ?? null, powerF: pm?.spend_forecast ?? null, gasF: gm?.spend_forecast ?? null };
  });
  return (
    <div className="h-72" data-testid="ea-chart-monthly-spend">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 0 }}>
          <HatchDefs id="ea-hatch-sp" color={COLORS.power} />
          <HatchDefs id="ea-hatch-sg" color={COLORS.gas} />
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
          <XAxis dataKey="label" tick={{ fontSize: 12, fill: "#64748B" }} axisLine={false} tickLine={false} />
          <YAxis tickFormatter={fmtEurCompact} tick={{ fontSize: 11, fill: "#64748B" }} axisLine={false} tickLine={false} width={72} />
          <Tooltip content={<SpendTooltip />} cursor={{ fill: "#F1F5F9" }} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          {hasP && <Bar dataKey="power" name="Power fatturato" stackId="s" fill={COLORS.power} />}
          {hasG && <Bar dataKey="gas" name="Gas fatturato" stackId="s" fill={COLORS.gas} />}
          {hasP && <Bar dataKey="powerF" name="Power stima forecast" stackId="s" fill="url(#ea-hatch-sp)" stroke={COLORS.power} strokeDasharray="3 2" />}
          {hasG && <Bar dataKey="gasF" name="Gas stima forecast" stackId="s" fill="url(#ea-hatch-sg)" stroke={COLORS.gas} strokeDasharray="3 2" />}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
